<template>
  <v-container v-if="currentImport && rows">
    <v-row>
      <v-col stretch>
        <v-breadcrumb :items="breadcrumbImportItems" :mobile="breadcrumbMobileItem"></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar :title="currentImport.title"> </v-title-bar>
      </v-col>
    </v-row>
    <v-row v-if="teamsSettings[$route.params.team]">
      <v-col class="col-12">
        <ul class="list">
          <v-list-item simple>
            <v-list-cell :title="$t('imports.type')" />
            <v-list-cell :value="$t('imports.types.' + currentImport.import_type)" size="2" />
            <v-list-cell value="" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('stati.status.title')" />
            <v-list-cell :value="formatImportStatus()" size="2" />
            <v-list-cell
              v-if="!importFinished"
              :button="$t('imports.update_status')"
              :onClick="
                () => {
                  reloadPage();
                }
              "
            />
            <v-list-cell v-if="importFinished" value="" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('labels.createdDate')" />
            <v-list-cell
              :value="$h.formatDate(currentImport.created_at, teams[$route.params.team].account.timezone)"
              size="2"
            />
            <v-list-cell value="" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('imports.rows.processed')" />
            <v-list-cell
              :value="currentImport.meta.rows.processed ? currentImport.meta.rows.processed : '0'"
              size="2"
            />
            <v-list-cell value="" />
          </v-list-item>
          <v-list-item simple>
            <v-list-cell :title="$t('imports.rows.failed')" />
            <v-list-cell :value="currentImport.meta.rows.failed ? currentImport.meta.rows.failed : '0'" size="2" />
            <v-list-cell value="" />
          </v-list-item>
        </ul>
      </v-col>
    </v-row>
    <v-row v-if="!reloading && rows.data && rows.data.length && teamsSettings[$route.params.team]">
      <v-col class="col-12">
        <v-list-header simple>
          <v-list-header-cell :title="$t('imports.failed_rows')" />
        </v-list-header>
      </v-col>
      <v-col class="col-12">
        <v-list-header complex>
          <v-list-header-cell emptyIcon />
          <v-list-header-cell size="1" :title="$t('imports.row_number')" />
          <v-list-header-cell :title="$t('imports.error')" size="2" />
        </v-list-header>
        <router-link
          :to="{
            name: 'ImportErrorRow',
            params: { uid: currentImport.uid, err: row.uid },
          }"
          v-for="row in rows.data"
          :key="row.uid"
        >
          <v-list-item complex hover>
            <v-list-cell icon="Icon=folder.svg" iconFill />
            <v-list-cell :title="row.row_number" size="1" />
            <v-list-cell size="2" :value="getError(row)" />
          </v-list-item>
        </router-link>
        <ul v-if="!rows.data.length">
          <v-list-item>
            <v-list-cell :value="$t('placeholders.noImports')"></v-list-cell>
          </v-list-item>
        </ul>
        <v-list-pagination
          :currentPage="rows.meta.pagination.current_page"
          :totalPages="rows.meta.pagination.last_page"
          :showPerPage="rows.meta.pagination.per_page"
          :apiCall="
            (page, perPage) => {
              changeImportRowsPage(page, perPage);
            }
          "
        >
        </v-list-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Import",
  data() {
    return {
      breadcrumbImportItems: [
        {
          label: this.$t("menus.settings"),
          route: { name: "Settings", params: { tab: "account" } },
        },
        {
          label: this.$t("menus.imports"),
          route: { name: "Settings", params: { tab: "imports" } },
        },
      ],
      breadcrumbMobileItem: {
        label: this.$t("menus.imports"),
        route: { name: "Settings", params: { tab: "imports" } },
      },
      isLoading: false,
      title: "",
      allowedFileTypes: [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ],
      excel: null,
      file: null,
      currentExcel: null,
      customFileErrors: [],
      reloading: false,
    };
  },
  created() {
    this.loadPageData(this.$route.params.uid);
  },
  methods: {
    ...mapActions(["getImport", "getImportErrors"]),
    reloadPage() {
      this.reloading = true;
      this.loadPageData(this.currentImport.uid);
    },
    loadPageData(uid) {
      const vm = this;
      vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      const p1 = vm.getImport({ params: { import: uid } });
      const p2 = vm.getImportErrors({ import: uid });
      Promise.all([p1, p2])
        .then(() => {
          if (!vm.reloading) {
            vm.breadcrumbImportItems.push({
              label: this.currentImport.title,
              active: true,
            });
          }
          vm.reloading = false;
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.resourceNotFound.import"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
          vm.reloading = false;
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        });
    },
    changeImportRowsPage(page, perPage) {
      const params = {
        search: "",
        page,
        per_page: perPage,
        order_col: "",
        order_dir: "",
        import_type: "",
      };
      const vm = this;
      this.getImportErrors({ import: this.currentImport.uid, params: params })
        .then(() => {
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        })
        .catch(() => {
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        });
    },
    formatImportStatus() {
      if (
        (this.currentImport.status & this.currentImport.meta.status.IMPORTED.bit) ===
        this.currentImport.meta.status.IMPORTED.bit
      ) {
        return this.$t("imports.status.imported");
      } else if (
        (this.currentImport.status & this.currentImport.meta.status.IMPORT_ERROR.bit) ===
        this.currentImport.meta.status.IMPORT_ERROR.bit
      ) {
        return this.$t("imports.status.import_error");
      } else if (
        (this.currentImport.status & this.currentImport.meta.status.IN_PROGRESS.bit) ===
        this.currentImport.meta.status.IN_PROGRESS.bit
      ) {
        return this.$t("imports.status.in_progress");
      }
      return this.$t("imports.status.init");
    },
    getError(row) {
      if ((row.status & this.rows.meta.status.DUPLICATE.bit) === this.rows.meta.status.DUPLICATE.bit) {
        let existentValue = "";
        const errorField = row.errors[0];
        for (const i in row.values) {
          if (i === errorField) {
            existentValue = row.values[i];
            break;
          }
        }
        return this.$t("imports.errors.existent", { email: existentValue });
      } else {
        let fieldList = "";
        for (const j in row.errors) {
          fieldList = fieldList ? fieldList + ", " + row.errors[j] : row.errors[j];
        }
        return this.$t("imports.errors.values", { fields: fieldList });
      }
    },
    getClientValue(colvalue, client) {
      const prefixes = colvalue.column.key.split(".");
      if (!prefixes[prefixes.length]) {
        prefixes.pop();
      }
      prefixes.push(colvalue.column.property);
      let obj = client;
      for (let i = 0; i < prefixes.length; i++) {
        if (typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, prefixes[i])) {
          obj = obj[prefixes[i]];
        } else {
          break;
        }
      }
      return typeof obj !== "object" ? obj : "";
    },
  },
  computed: {
    importFinished() {
      return (
        this.currentImport &&
        ((this.currentImport.status & this.currentImport.meta.status.IMPORTED.bit) ===
          this.currentImport.meta.status.IMPORTED.bit ||
          (this.currentImport.status & this.currentImport.meta.status.IMPORT_ERROR.bit) ===
            this.currentImport.meta.status.IMPORT_ERROR.bit)
      );
    },
    ...mapGetters({
      teams: "auth_get_teams",
      currentImport: "import_get_current_import",
      rows: "import_get_current_import_rows",
      teamLanguages: "teams_get_languages",
      teamsSettings: "global_get_teams_settings",
    }),
  },
};
</script>
